<template>
    <restaurant-detail
        class="restaurant-opening-hours"
        :title="$snippet('opening_hours', 'opening hours')"
    >
        <p
            v-if="notice"
            class="notice"
            v-test:notice
        >
            {{ notice }}
        </p>

        <b-row
            v-for="day in mappedOpeningHours"
            :key="day.label"
        >
            <b-col v-test:dayLabel>
                {{ day.label }}
            </b-col>
            <b-col v-test:dayOpening>
                <template v-if="day.open && day.close">
                    {{ day.open }} - {{ day.close }}
                </template>
                <template v-else>
                    {{ $snippet('closed', 'closed') }}
                </template>
            </b-col>
        </b-row>
    </restaurant-detail>
</template>

<script>
    import RestaurantDetail from '../../molecules/RestaurantDetail/RestaurantDetail';
    import dayjs from 'dayjs';
    import customParseFormat from 'dayjs/plugin/customParseFormat';

    dayjs.extend(customParseFormat);

    export default {
        name: 'restaurant-opening-hours',

        components: { RestaurantDetail },

        props: {
            openingHours: {
                type: Object,
                required: true,
            },

            notice: {
                type: String,
                default: '',
            },
        },

        computed: {
            /**
             * Format the provided opening hours for display.
             *
             * @returns {{open: string|null, close: string|null, label: string}[]}
             */
            mappedOpeningHours() {
                return [
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday',
                    'Sunday',
                ].map((label) => {
                    const { open, close } = this.openingHours[label.toLowerCase()];

                    return {
                        label,
                        open: open
                            ? dayjs(open, 'HH:mm').format('h:mma')
                                .replace(':00', '')
                            : null,
                        close: close
                            ? dayjs(close, 'HH:mm').format('h:mma')
                                .replace(':00', '')
                            : null,
                    };
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .notice {
        font-size: 0.75rem;
        font-weight: bold;
        color: primary-palette(1);
    }
</style>
